module.exports = __webpack_public_path__ + "img/red_del_icon.41f26517.svg";